export const time = [
    {
        time: '01:00:00',
        label: '01:00',
        availability: true,
    },
    {
        time: '02:00:00',
        label: '02:00',
        availability: true,
    },
    {
        time: '03:00:00',
        label: '03:00',
        availability: true,
    },
    {
        time: '04:00:00',
        label: '04:00',
        availability: true,
    },
    {
        time: '05:00:00',
        label: '05:00',
        availability: true,
    },
    {
        time: '06:00:00',
        label: '06:00',
        availability: true,
    },
    {
        time: '07:00:00',
        label: '07:00',
        availability: true,
    },
    {
        time: '08:00:00',
        label: '08:00',
        availability: true,
    },
    {
        time: '09:00:00',
        label: '09:00',
        availability: true,
    },
    {
        time: '10:00:00',
        label: '10:00',
        availability: false,
    },
    {
        time: '11:00:00',
        label: '11:00',
        availability: false,
    },
    {
        time: '12:00:00',
        label: '12:00',
        availability: false,
    },
    {
        time: '13:00:00',
        label: '13:00',
        availability: false,
    },
    {
        time: '14:00:00',
        label: '14:00',
        availability: false,
    },
    {
        time: '15:00:00',
        label: '15:00',
        availability: false,
    },
    {
        time: '16:00:00',
        label: '16:00',
        availability: false,
    },
    {
        time: '17:00:00',
        label: '17:00',
        availability: false,
    },
    {
        time: '18:00:00',
        label: '18:00',
        availability: false,
    },
    {
        time: '19:00:00',
        label: '19:00',
        availability: false,
    },
    {
        time: '20:00:00',
        label: '20:00',
        availability: false,
    },
    {
        time: '21:00:00',
        label: '21:00',
        availability: false,
    },
    {
        time: '22:00:00',
        label: '22:00',
        availability: false,
    },
    {
        time: '23:00:00',
        label: '23:00',
        availability: false,
    },
    {
        time: '24:00:00',
        label: '24:00',
        availability: false,
    },
];
